var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPencil(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Design / Pencil"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Style",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.4941 3.99408C12.74 2.74817 14.76 2.74817 16.0059 3.99408C17.2089 5.19703 17.2504 7.12162 16.1304 8.37434L16.0059 8.50592L15.1728 9.33902C15.1727 9.3391 15.1727 9.33918 15.1726 9.33926C15.1725 9.33934 15.1724 9.33941 15.1724 9.33949L7.25592 17.2559C7.12569 17.3862 6.95679 17.4688 6.7762 17.4928L6.66667 17.5H3.33333C2.90597 17.5 2.55374 17.1783 2.50561 16.7639L2.5 16.6667V13.3333C2.5 13.1492 2.56097 12.9713 2.67173 12.8266L2.74408 12.7441L10.6607 4.82741L11.4941 3.99408ZM11.25 6.59517L4.16667 13.6783V15.8325H6.32083L13.4047 8.74988L11.25 6.59517ZM14.5833 7.57147L12.4285 5.41667L12.6726 5.17259L12.7751 5.07893C13.3737 4.57939 14.2654 4.61061 14.8274 5.17259L14.9211 5.27506C15.4206 5.87368 15.3894 6.76543 14.8274 7.32741L14.5833 7.57147Z",
    fill: "#6B7280"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPencil);
export default __webpack_public_path__ + "static/media/pencil.163b9c1024537a9cac4fc4fc6465d20b.svg";
export { ForwardRef as ReactComponent };